import { Link } from "react-router-dom"
import { Trophy, ArrowLeft, ExternalLink } from "lucide-react"
import { AppShell } from "@/components/AppShell"
import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"

/**
 * Ambition integration placeholder — deferred by design.
 */
export default function AmbitionPage() {
  return (
    <AppShell title="Ambition" subtitle="Aggregation platform integration">
      <div className="mx-auto max-w-3xl space-y-6">
        <Card className="p-8 text-center">
          <div className="mx-auto mb-4 grid h-16 w-16 place-items-center rounded-full bg-amber-50 text-amber-600">
            <Trophy className="h-8 w-8" />
          </div>
          <h2 className="text-xl font-semibold text-foreground">Ambition integration</h2>
          <p className="text-muted-foreground mx-auto mt-2 max-w-md text-sm">
            Two-way sync between Rivercity CRM and the Ambition aggregation platform.
          </p>
          <Badge variant="muted" className="mt-4">
            Coming soon
          </Badge>
        </Card>

        <Card className="p-6">
          <h3 className="mb-3 text-sm font-semibold text-foreground">Planned scope</h3>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Sync deal status changes to Ambition</li>
            <li>• Pull commission and settlement data back from Ambition</li>
            <li>• Reconcile paid vs. expected commission on the Reports page</li>
          </ul>
          <p className="text-muted-foreground mt-4 text-xs">
            The API architecture is ready for this integration — it just isn't wired up yet.
          </p>
        </Card>

        <Card className="border-amber-200 bg-amber-50 p-4">
          <p className="text-sm text-amber-900">
            <strong>For now,</strong> continue managing lender submissions in your existing Ambition
            workspace at{" "}
            <a
              href="https://ambition.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 underline hover:no-underline"
            >
              ambition.com.au <ExternalLink className="h-3 w-3" />
            </a>
            .
          </p>
        </Card>

        <div className="text-center">
          <Button asChild variant="outline">
            <Link to="/">
              <ArrowLeft className="h-4 w-4" />
              Back to Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </AppShell>
  )
}
